import React, { useRef, useEffect } from 'react';
import { FunctionColor, Preset, Text } from '@lux/text';
import { TitlePreset } from '@lux/title';
import { ButtonColor, ButtonType } from '@lux/buttons';
import { Translate, TranslateScope } from '@pegasus/translation';
import { InView } from 'react-intersection-observer';
import * as S from './styles';
import TimeLeft from './time-left';
import { Carousel } from './carousel';
import { showstopperTracker } from './tracking';
export var Showstopper = function (_a) {
    var content = _a.content, dateTill = _a.dateTill, discount = _a.discount, headline = _a.headline, link = _a.link, title = _a.title, carouselItems = _a.carouselItems, media = _a.media, position = _a.position, categoryTabId = _a.categoryTabId, visitorID = _a.visitorID, isMobileScreen = _a.isMobileScreen;
    var carouselRef = useRef(null);
    var scrollToCarousel = function () {
        var _a;
        showstopperTracker.track('getInspired_multiCampaign_clickHeader', {
            isGetInspired: '1',
            getInspiredLength: carouselItems.length,
        });
        (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'end' });
    };
    useEffect(function () {
        showstopperTracker.track('getInspired_multiCampaign_available', {
            isGetInspired: '1',
            getInspiredLength: carouselItems.length,
        });
    }, []);
    var onViewChange = function (isInView) {
        if (isInView) {
            showstopperTracker.track('getInspired_multiCampaign_shown', {
                isGetInspired: '1',
                getInspiredLength: carouselItems.length,
            });
        }
    };
    if (!content || !title) {
        return null;
    }
    var titlePreset = isMobileScreen ? TitlePreset.XS : TitlePreset.M;
    return (React.createElement(TranslateScope, { path: "mylounge" },
        React.createElement(S.BackgroundContainer, null,
            React.createElement(InView, { as: "div", onChange: onViewChange, triggerOnce: true },
                React.createElement(S.GridContainer, { role: "button", tabIndex: 0, onClick: scrollToCarousel },
                    headline && (React.createElement(Text, { preset: Preset.L, bold: true }, headline)),
                    title && (React.createElement(S.StyledTitle, { preset: titlePreset, color: FunctionColor.function0 }, title)),
                    content && (React.createElement(S.ContentWrapper, null,
                        React.createElement(Text, { preset: Preset.M, color: FunctionColor.function0 }, content))),
                    link && (React.createElement(S.StyledButton, { buttonType: ButtonType.tertiary, color: ButtonColor.dark }, link)),
                    media && (React.createElement(S.MediaWrapper, null,
                        React.createElement("img", { src: media.desktop, alt: title }))),
                    discount && dateTill && (React.createElement(S.TimerWrapper, { media: media },
                        React.createElement(TimeLeft, { dateTill: dateTill, color: FunctionColor.function0 }),
                        React.createElement(S.StyledKicker, { title: React.createElement(Translate, { message: "campaigns.upTo" }), titlePreset: Preset.S },
                            React.createElement(S.KickerText, { preset: Preset.S, bold: true, color: FunctionColor.function0 },
                                discount,
                                "%"))))),
                React.createElement("div", { ref: carouselRef },
                    React.createElement(S.BackgroundContainerCarousel, null,
                        React.createElement(S.CarouselWrapper, null,
                            React.createElement(Carousel, { showStopperPosition: position, categoryTabId: categoryTabId, visitorID: visitorID, isMobileScreen: isMobileScreen, carouselItems: carouselItems }))))))));
};
